export default [
  {
    path: '/',
    name: 'home',
    component: () => import('@/pages/Home.vue'),
    meta: {
      requiresAuth: true,
      title: 'Главная',
      layout: 'default',
    },
  },
  {
    path: '/demo/custom-script',
    name: 'demo-custom-script',
    component: () => import('@/pages/DemoCustomScript.vue'),
    meta: {
      requiresAuth: true,
      title: 'Демо executeCustomScript',
      layout: 'default',
    },
  },
  // {
  //   path: '/order/operator',
  //   name: 'operator-order',
  //   component: () => import('@/pages/OperatorOrder.vue'),
  //   meta: {
  //     requiresAuth: false,
  //     title: 'Заказ — для одного оператора ПД',
  //     layout: 'embed',
  //   },
  // },
]
